export default __webpack_public_path__ + "static/media/warning--double-reverse-curve-right--g1.ce6cc21b.png";